import React from 'react';

const ScrollToTopArrow = () => (
  <svg
    preserveAspectRatio="xMidYMid meet"
    viewBox="46.141 20.63 107.717 158.741"
    height="40"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <g>
      <path d="m153.858 130.731-53.857 48.64-53.86-48.64 1.804-1.944 50.722 45.809V20.63h2.669v153.965l50.719-45.809 1.803 1.945z" />
    </g>
  </svg>
);

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="bg-black text-white border-t border-gray-800 mt-16">
      <div className="grid grid-cols-1 md:grid-cols-2">
          {/* Left column */}
          <div className="flex justify-end py-16">
            <div className="w-full max-w-lg px-8 lg:px-16">
            <a
              href="https://www.mandarintutorhk.com"
              className="text-2xl font-bold text-white hover:text-gray-300 transition-colors no-underline"
            >
              Aileen<span className="text-purple-500">.</span>
            </a>
            <p className="text-xs text-gray-400 mt-0.5 mb-8">Mandarin &amp; Cantonese Tutor HK</p>

            <h2 className="text-5xl font-light leading-tight mb-8">
              Join Our Classes Today!
            </h2>

            <a
              href="https://book.mandarintutorhk.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#7e55f6] hover:bg-[#6a46d1] text-white text-sm font-medium px-8 py-4 transition-all duration-200 no-underline shadow-md hover:shadow-lg"
            >
              Book Your Chinese Class Now
            </a>
          </div>
          </div>

          {/* Right column */}
          <div className="md:border-l border-gray-800 py-16 relative">
            <div className="w-full max-w-lg px-8 lg:px-16">
            {/* Info */}
            <h3 className="text-2xl font-normal mb-4">Info</h3>
            <div className="space-y-1 text-base leading-relaxed mb-8">
              <p>
                WhatsApp:{' '}
                <a
                  href="https://wa.me/85251776613"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="underline text-white hover:text-purple-400"
                >
                  +852-5177-6613
                </a>
              </p>
              <p>
                Email:{' '}
                <a
                  href="mailto:aileen@mandarintutorhk.com?subject=Inquiry%20about%20Mandarin%20and%20Cantonese%20Lessons"
                  className="underline text-white hover:text-purple-400"
                >
                  aileen@mandarintutorhk.com
                </a>
              </p>
              <p>By appointment only.</p>
              <p>Monday - Sunday: 8 AM - 10 PM.</p>
            </div>

            {/* Address */}
            <h3 className="text-2xl font-normal mb-4">Address</h3>
            <div className="text-base leading-relaxed mb-8">
              <p>
                Suite 316 3/F, Dah Sing Life Building
                <br />
                99-105 Des Voeux Road Central, Hong Kong
              </p>
            </div>

            {/* Follow */}
            <h3 className="text-2xl font-normal mb-4">Follow</h3>
            <div className="text-base leading-relaxed space-y-1">
              <p>
                <a
                  href="https://www.linkedin.com/company/mandarin-cantonese-tutor-hong-kong"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="underline text-white hover:text-purple-400"
                >
                  LinkedIn
                </a>
              </p>
              <p>
                <a
                  href="https://www.facebook.com/Mandarin.Cantonese.Tutor.HK/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="underline text-white hover:text-purple-400"
                >
                  Facebook
                </a>
              </p>
              <p>
                <a
                  href="https://www.instagram.com/aileen.ting99/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="underline text-white hover:text-purple-400"
                >
                  Instagram
                </a>
              </p>
            </div>

            {/* Scroll to top */}
            <button
              onClick={scrollToTop}
              aria-label="Scroll to top"
              className="absolute bottom-4 right-4 text-white hover:text-purple-400 transition-colors rotate-180"
            >
              <ScrollToTopArrow />
            </button>
            </div>
          </div>
        </div>
    </footer>
  );
};

export default Footer;
